module.exports = __webpack_public_path__ + "img/contract.9b8b5b7d.svg";